import createModel from 'utils/model'
import {getShopList, createShop, editShop} from 'app-self-support-order/services/shop-manage'
import _ from 'lodash'

export default createModel({
    namespace: 'selfSupportOrder_shopManagement',

    state: {
        tableData: {},
        authUrl: undefined, // 店铺授权地址
        isVisibleAuthBack: false, // 点击授权后的弹窗
    },

    effects: {
        // 获取店铺列表
        *getTableData(xx, {select, put, call}) {
            const {tableData} = yield select(
                ({selfSupportOrder_shopManagement}) => selfSupportOrder_shopManagement,
            )

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(getShopList, {...newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        // 创建店铺
        *createShop({payload, callback}, {call}) {
            const res = yield call(createShop, payload)
            if (res) {
                callback && callback(res)
            }
        },

        // 编辑店铺
        *editShop({payload, callback}, {call}) {
            const res = yield call(editShop, payload)
            if (res) {
                callback && callback(res)
            }
        },
    },
})
